<template>
  <div id="app" class="min-h-screen flex flex-col">
    <Navbar v-if="!$route.meta.hideNavbar" />
    <div class="flex-1 page-wrapper">
      <transition name="page" mode="out-in">
        <keep-alive :include="cachedViews">
          <router-view v-if="$route.meta.keepAlive !== false" :key="$route.fullPath" />
        </keep-alive>
      </transition>
      <transition name="page" mode="out-in">
        <router-view v-if="$route.meta.keepAlive === false" :key="$route.fullPath" />
      </transition>
    </div>
    <Footer v-if="!$route.meta.hideNavbar" />
    <!-- 居中消息弹窗 -->
    <MessageDialog ref="messageDialog" />
  </div>
</template>

<script>
import Navbar from './components/Navbar.vue'
import Footer from './components/Footer.vue'
import MessageDialog from './components/MessageDialog.vue'
import { initMessageDialog } from './utils/toast'

export default {
  name: 'App',
  components: {
    Navbar,
    Footer,
    MessageDialog
  },
  data() {
    return {
      // 需要缓存的页面组件名称列表
      cachedViews: [
        'HomePage',
        'ProductListPage',
        'ProductDetailPage',
        'BlacklistPage'
      ]
    }
  },
  mounted() {
    // 初始化 MessageDialog
    initMessageDialog(this.$refs.messageDialog)
  }
}
</script>

<style>
/* 全局样式已移至 theme.css 和 tailwind.css */

/* 页面切换动画 - 淡入淡出 + 轻微上移 */
.page-enter-active,
.page-leave-active {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.page-enter {
  opacity: 0;
  transform: translateY(10px);
}

.page-enter-to {
  opacity: 1;
  transform: translateY(0);
}

.page-leave {
  opacity: 1;
  transform: translateY(0);
}

.page-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

/* 页面内容区域动画 */
.page-content {
  animation: fadeInUp 0.4s ease-out;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 按钮点击反馈动画 */
button, .btn-clickable {
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}

button:active, .btn-clickable:active {
  transform: scale(0.97);
}

/* 链接悬停动画 */
a {
  transition: color 0.2s ease;
}

/* 卡片悬停动画 */
.card-hover {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.card-hover:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 24px -8px rgba(0, 0, 0, 0.15);
}
</style>
